import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// custom components
import { SearchBar } from "_atoms";
import GateRelocationAlert from "./gate-relocation-alert";
import PhoneOptionsMenu from "./phone-options-menu";

// redux
import { useSelector, useDispatch } from "react-redux";
import {
    setEmployeeFilter,
    setEmployeeSearch,
    selectEmployeeSearchTerm,
    selectAddEmployeeStatus,
    resetAddEmployeeForm
} from "_redux/slices/timeline/employees";
import { setSearchedFlight } from '_redux/slices/timeline/flight-information-list';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { setBookingSearch } from '_redux/slices/timeline/timeline-data';

// styling
import { Spacing } from "_styles";
import { IS_PHONE_TIMELINE } from "../timeline-constants";
import { IoChevronBack } from "react-icons/io5";

const TimelineToolbar = (props) => {

    //#region redux
    const dispatch = useDispatch();

    const searchTerm = useSelector(selectEmployeeSearchTerm);
    const addEmployeeStatus = useSelector(selectAddEmployeeStatus);

    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    const history = useHistory();

    //#region local states    
    //#endregion

    //#region useEffect
    useEffect(() => {
        dispatch(setEmployeeFilter("online"))   // default to online
        dispatch(setBookingSearch(""));
        dispatch(setSearchedFlight(""));
    }, []);

    useEffect(() => {
        if (addEmployeeStatus === "succeeded") {
            handleCloseModal();
        }
    }, [addEmployeeStatus]);
    //#endregion

    //#region functions
    const handleCloseModal = () => {
        dispatch(resetAddEmployeeForm());
    };


    //#endregion

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: usedTheme.BACKGROUND_COLOR,
        }}>

            {/* employee search filter (full width on phones, with the back, options and Now buttons beside it) */}
            <div style={{ display: 'flex', padding: IS_PHONE_TIMELINE ? '6px 8px' : Spacing.SCALE_4, flex: 1, alignItems: 'center', gap: IS_PHONE_TIMELINE ? 8 : 0, minWidth: 0 }}>
                {/* phones hide TimelineTitles, so this is the only way back to the area list */}
                {IS_PHONE_TIMELINE && (
                    <button type="button" onClick={() => history.push("/timeline-v2")} aria-label="Back to timeline areas" style={backButtonStyle}>
                        <IoChevronBack size={22} />
                    </button>
                )}
                <SearchBar
                    employee={true}
                    onChange={(event) => dispatch(setEmployeeSearch(event.target.value))}
                    placeholder={`Employee Filter`}
                    value={searchTerm}
                    timeline={true}
                    style={IS_PHONE_TIMELINE ? { flex: 1, minWidth: 0, maxWidth: 'none' } : undefined}
                    inputStyle={IS_PHONE_TIMELINE ? { fontSize: 16 } : undefined}
                />
                {/* control panel / locations / broadcast messages / tomorrow — the hidden header's options */}
                {IS_PHONE_TIMELINE && <PhoneOptionsMenu showLocations={props.showLocations} onToggleLocations={props.onToggleLocations} />}
                {IS_PHONE_TIMELINE && props.onNow && (
                    <button type="button" onClick={props.onNow} aria-label="Scroll to the current time" style={nowButtonStyle}>
                        Now
                    </button>
                )}
            </div>

            {/* unassigned gate relocation alert (ignores job type filter) */}
            <GateRelocationAlert />

        </div>
    );
};

const backButtonStyle = {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: Spacing.SCALE_38,
    height: Spacing.SCALE_38,
    padding: 0,
    border: 'none',
    borderRadius: 6,
    color: '#fff',
    backgroundColor: '#307FE2',
};

const nowButtonStyle = {
    flexShrink: 0,
    height: Spacing.SCALE_38,
    padding: '0 16px',
    border: 'none',
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 700,
    color: '#fff',
    backgroundColor: '#DE3700',
};

export default TimelineToolbar;
